var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded && _vm.receiptLogUnit)?_c('ReceiptLogUnitDetail',{attrs:{"receipt-log-unit":_vm.receiptLogUnit},on:{"download":_vm.downloadFile,"requestDelivery":_vm.requestDelivery}}):(_vm.loaded)?_c('Page404',{attrs:{"message":"That Receipt Log unit was not found"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }